import UserService from '@/services/users';

export default {
  props: {

  },
  data:
    function () {
      return {
        userTimeZoneId: 'Pacific Standard Time',
        userTimeZoneUtcOffset: 0
      }
    },
  methods: {
    async getUserTimeZoneInfo() {
      var response = await UserService.getUserSettings();
      this.userTimeZoneId = response && response.timeZoneId || this.userTimeZoneId;
      this.userTimeZoneUtcOffset = response && response.timeZoneUtcOffset || this.userTimeZoneUtcOffset;
    },
    localizeDate(date) {
      var localizedDate = new Date(date);
      localizedDate.setHours(localizedDate.getHours() + this.userTimeZoneUtcOffset);
      return localizedDate.toLocaleString();
    }
  },
  async mounted () {
    await this.getUserTimeZoneInfo();
  }
}
